var n,t;!function(n){n.NEW_WINDOW="_blank",n.SELF="_self",n.PARENT="_parent",n.TOP="_top"}(n||(n={})),function(n){n.START="start",n.END="end"}(t||(t={}));export{t as IconPosition,n as LinkTarget};
//# sourceMappingURL=LinkConsts.js.map
